/**
 * Viloyat va tuman nomlari (ru/en) — API faqat o‘zbekcha (va viloyat uchun ruscha) qaytaradi.
 * District uchun name_ru bazada bo‘sh bo‘lishi mumkin — shuning uchun frontend kalitlari.
 * Kalitlar backend DistrictResource bilan mos: region_andijon, district_andijon, ...
 */
export const regionDistrictLabels = {
  ru: {
    region_andijon: 'Андижанская область',
    region_buxoro: 'Бухарская область',
    region_fargona: 'Ферганская область',
    region_jizzax: 'Джизакская область',
    region_qashqadaryo: 'Кашкадарьинская область',
    region_navoiy: 'Навоийская область',
    region_namangan: 'Наманганская область',
    region_samarqand: 'Самаркандская область',
    region_sirdaryo: 'Сырдарьинская область',
    region_surxondaryo: 'Сурхандарьинская область',
    region_toshkent_viloyati: 'Ташкентская область',
    region_toshkent_shahri: 'город Ташкент',
    region_xorazm: 'Хорезмская область',
    region_qoraqalpokiston: 'Республика Каракалпакстан',
    region_qoraqalpoq: 'Республика Каракалпакстан',
    region_toshkent: 'Ташкент',
    district_amudaryo: 'Амударьинский район',
    district_andijon: 'Андижанский район',
    district_angor: 'Ангорский район',
    district_arnasoy: 'Арнасайский район',
    district_asaka: 'Асакинский район',
    district_bagdod: 'Багдадский район',
    district_baliqchi: 'Балыкчинский район',
    district_bandixon: 'Бандиханский район',
    district_baxmal: 'Бахмальский район',
    district_bekobod: 'Бекабадский район',
    district_bektemir: 'Бектемирский район',
    district_beruniy: 'Берунийский район',
    district_beshariq: 'Бешарыкский район',
    district_bogot: 'Багатский район',
    district_boka: 'Букинский район',
    district_boston: 'Бустонский район',
    district_bostonliq: 'Бустонлыкский район',
    district_boyovut: 'Баяутский район',
    district_boysun: 'Байсунский район',
    district_bozatov: 'Бозатауский район',
    district_buloqboshi: 'Булакбашинский район',
    district_bulungur: 'Булунгурский район',
    district_buvayda: 'Бувайдинский район',
    district_buxoro: 'Бухарский район',
    district_chilanzar: 'Чиланзарский район',
    district_chimboy: 'Чимбайский район',
    district_chinoz: 'Чиназский район',
    district_chiroqchi: 'Чиракчинский район',
    district_chortoq: 'Чартакский район',
    district_chust: 'Чустский район',
    district_dangara: 'Дангараский район',
    district_dehqonobod: 'Дехканабадский район',
    district_denov: 'Денауский район',
    district_dostlik: 'Дустликский район',
    district_ellikqala: 'Элликкалинский район',
    district_fargona: 'Ферганский район',
    district_forish: 'Фаришский район',
    district_furqat: 'Фуркатский район',
    district_gallaorol: 'Галлааральский район',
    district_gijduvon: 'Гиждуванский район',
    district_guliston: 'Гулистанский район',
    district_gurlan: 'Гурленский район',
    district_guzor: 'Гузарский район',
    district_hazorasp: 'Хазараспский район',
    district_ishtixon: 'Иштыханский район',
    district_izboskan: 'Избасканский район',
    district_jalaquduq: 'Джалакудукский район',
    district_jarqorgon: 'Джаркурганский район',
    district_jomboy: 'Джамбайский район',
    district_jondor: 'Жондорский район',
    district_karmana: 'Карманинский район',
    district_kasbi: 'Касбинский район',
    district_kattaqorgon: 'Каттакурганский район',
    district_kegeyli: 'Кегейлийский район',
    district_kitob: 'Китабский район',
    district_kogon: 'Каганский район',
    district_kokdala: 'Кокдалинский район',
    district_konimex: 'Канимехский район',
    district_koson: 'Касанский район',
    district_kosonsoy: 'Касансайский район',
    district_marhamat: 'Мархаматский район',
    district_mingbuloq: 'Мингбулакский район',
    district_mirishkor: 'Миришкорский район',
    district_mirobod: 'Мирабадский район',
    district_mirzachol: 'Мирзачульский район',
    district_mirzaobod: 'Мирзаабадский район',
    district_mirzo_ulugbek: 'Мирзо-Улугбекский район',
    district_moynoq: 'Муйнакский район',
    district_muborak: 'Мубарекский район',
    district_muzrabot: 'Музрабадский район',
    district_namangan: 'Наманганский район',
    district_narpay: 'Нарпайский район',
    district_navbahor: 'Навбахорский район',
    district_nishon: 'Нишанский район',
    district_norin: 'Нарынский район',
    district_nukus: 'Нукусский район',
    district_nurobod: 'Нурабадский район',
    district_nurota: 'Нуратинский район',
    district_ohangaron: 'Охангаранский район',
    district_olmazor: 'Алмазарский район',
    district_olot: 'Алатский район',
    district_oltiariq: 'Алтыарыкский район',
    district_oltinkol: 'Алтынкульский район',
    district_oltinsoy: 'Алтынсайский район',
    district_oqdaryo: 'Акдарьинский район',
    district_oqoltin: 'Акалтынский район',
    district_oqqorgon: 'Аккурганский район',
    district_ortachirchiq: 'Уртачирчикский район',
    district_parkent: 'Паркентский район',
    district_pastdargom: 'Пастдаргомский район',
    district_paxtachi: 'Пахтачинский район',
    district_paxtakor: 'Пахтакорский район',
    district_paxtaobod: 'Пахтаабадский район',
    district_payariq: 'Пайарыкский район',
    district_peshku: 'Пешкунский район',
    district_piskent: 'Пскентский район',
    district_pop: 'Попский район',
    district_qamashi: 'Камашинский район',
    district_qanlikol: 'Канлыкульский район',
    district_qarshi: 'Каршинский район',
    district_qibray: 'Кибрайский район',
    district_qiziltepa: 'Кызылтепинский район',
    district_qiziriq: 'Кизирийский район',
    district_qongirot: 'Кунградский район',
    district_qorakol: 'Каракульский район',
    district_qoraozak: 'Караозякский район',
    district_qorgontepa: 'Кургантепинский район',
    district_qorovulbozor: 'Караулбазарский район',
    district_qoshkopir: 'Кушкирпинский район',
    district_qoshrabot: 'Кушрабадский район',
    district_qoshtepa: 'Куштепинский район',
    district_qumqorgon: 'Кумкурганский район',
    district_quva: 'Кувинский район',
    district_quyichirchiq: 'Куйичирчикский район',
    district_rishton: 'Риштанский район',
    district_romitan: 'Ромитанский район',
    district_samarqand: 'Самаркандский район',
    district_sardoba: 'Сардобинский район',
    district_sariosiyo: 'Сарыасийский район',
    district_sayxunobod: 'Сайхунабадский район',
    district_sergeli: 'Сергелийский район',
    district_shahrisabz: 'Шахрисабзский район',
    district_shahrixon: 'Шахриханский район',
    district_sharof_rashidov: 'район имени Шарафа Рашидова',
    district_shayxontoxur: 'Шайхантахурский район',
    district_sherobod: 'Шерабадский район',
    district_shofirkon: 'Шафирканский район',
    district_shorchi: 'Шурчинский район',
    district_shovot: 'Шаватский район',
    district_shumanay: 'Шуманайский район',
    district_sirdaryo: 'Сырдарьинский район',
    district_sox: 'Сохский район',
    district_taxiatosh: 'Тахиаташский район',
    district_taxtakopir: 'Тахтакупырский район',
    district_termiz: 'Термезский район',
    district_tomdi: 'Тамдынский район',
    district_toraqorgon: 'Туракурганский район',
    district_tortkol: 'Турткульский район',
    district_toshkent: 'Ташкентский район',
    district_toshloq: 'Ташлакский район',
    district_toyloq: 'Тайлакский район',
    district_tuproqqala: 'Тупраккалинский район',
    district_uchkoprik: 'Учкуприкский район',
    district_uchqorgon: 'Учкурганский район',
    district_uchquduq: 'Учкудукский район',
    district_uchtepa: 'Учтепинский район',
    district_ulugnor: 'Улугнарский район',
    district_urganch: 'Ургенчский район',
    district_urgut: 'Ургутский район',
    district_uychi: 'Уйчинский район',
    district_uzbekiston: 'Узбекистанский район',
    district_uzun: 'Узунский район',
    district_vobkent: 'Вабкентский район',
    district_xatirchi: 'Хатырчинский район',
    district_xiva: 'Хивинский район',
    district_xojaobod: 'Ходжаабадский район',
    district_xojayli: 'Ходжейлийский район',
    district_xonqa: 'Ханкинский район',
    district_xovos: 'Хавастский район',
    district_yakkabog: 'Яккабагский район',
    district_yakkasaray: 'Яккасарайский район',
    district_yangiariq: 'Янгиарыкский район',
    district_yangibozor: 'Янгибазарский район',
    district_yangihayot: 'Янгихаятский район',
    district_yangiobod: 'Янгиабадский район',
    district_yangiqorgon: 'Янгикурганский район',
    district_yangiyol: 'Янгиюльский район',
    district_yashnobod: 'Яшнабадский район',
    district_yozyovon: 'Язявонский район',
    district_yunusobod: 'Юнусабадский район',
    district_yuqorichirchiq: 'Юкарычирчикский район',
    district_zafarobod: 'Зафарабадский район',
    district_zangiota: 'Зангиатинский район',
    district_zarbdor: 'Зарбдарский район',
    district_zomin: 'Зааминский район',
  },
  en: {
    region_andijon: 'Andijan Region',
    region_buxoro: 'Bukhara Region',
    region_fargona: 'Fergana Region',
    region_jizzax: 'Jizzakh Region',
    region_qashqadaryo: 'Kashkadarya Region',
    region_navoiy: 'Navoiy Region',
    region_namangan: 'Namangan Region',
    region_samarqand: 'Samarkand Region',
    region_sirdaryo: 'Syrdarya Region',
    region_surxondaryo: 'Surkhandarya Region',
    region_toshkent_viloyati: 'Tashkent Region',
    region_toshkent_shahri: 'Tashkent City',
    region_xorazm: 'Khorezm Region',
    region_qoraqalpokiston: 'Republic of Karakalpakstan',
    region_qoraqalpoq: 'Republic of Karakalpakstan',
    region_toshkent: 'Tashkent',
    district_amudaryo: 'Amudarya District',
    district_andijon: 'Andijan District',
    district_angor: 'Angor District',
    district_arnasoy: 'Arnasoy District',
    district_asaka: 'Asaka District',
    district_bagdod: 'Baghdad District',
    district_baliqchi: 'Baliqchi District',
    district_bandixon: 'Bandixon District',
    district_baxmal: 'Baxmal District',
    district_bekobod: 'Bekabad District',
    district_bektemir: 'Bektemir District',
    district_beruniy: 'Beruniy District',
    district_beshariq: 'Beshariq District',
    district_bogot: 'Bagat District',
    district_boka: "Bo'ka District",
    district_boston: "Bo'ston District",
    district_bostonliq: "Bo'stonliq District",
    district_boyovut: 'Boyovut District',
    district_boysun: 'Boysun District',
    district_bozatov: "Bo'zatov District",
    district_buloqboshi: 'Buloqboshi District',
    district_bulungur: 'Bulungur District',
    district_buvayda: 'Buvayda District',
    district_buxoro: 'Bukhara District',
    district_chilanzar: 'Chilanzar District',
    district_chimboy: 'Chimboy District',
    district_chinoz: 'Chinoz District',
    district_chiroqchi: 'Chiroqchi District',
    district_chortoq: 'Chortoq District',
    district_chust: 'Chust District',
    district_dangara: "Dang'ara District",
    district_dehqonobod: 'Dehqonobod District',
    district_denov: 'Denov District',
    district_dostlik: "Do'stlik District",
    district_ellikqala: 'Ellikqal’a District',
    district_fargona: 'Fergana District',
    district_forish: 'Forish District',
    district_furqat: 'Furqat District',
    district_gallaorol: "G'allaorol District",
    district_gijduvon: "G'ijduvon District",
    district_guliston: 'Guliston District',
    district_gurlan: 'Gurlan District',
    district_guzor: "G'uzor District",
    district_hazorasp: 'Hazorasp District',
    district_ishtixon: 'Ishtixon District',
    district_izboskan: 'Izboskan District',
    district_jalaquduq: 'Jalaquduq District',
    district_jarqorgon: "Jarqo'rg'on District",
    district_jomboy: 'Jomboy District',
    district_jondor: 'Jondor District',
    district_karmana: 'Karmana District',
    district_kasbi: 'Kasbi District',
    district_kattaqorgon: "Kattaqo'rg'on District",
    district_kegeyli: 'Kegeyli District',
    district_kitob: 'Kitob District',
    district_kogon: 'Kogon District',
    district_kokdala: "Ko'kdala District",
    district_konimex: 'Konimex District',
    district_koson: 'Koson District',
    district_kosonsoy: 'Kosonsoy District',
    district_marhamat: 'Marhamat District',
    district_mingbuloq: 'Mingbuloq District',
    district_mirishkor: 'Mirishkor District',
    district_mirobod: 'Mirobod District',
    district_mirzachol: "Mirzacho'l District",
    district_mirzaobod: 'Mirzaobod District',
    district_mirzo_ulugbek: "Mirzo Ulug'bek District",
    district_moynoq: "Mo'ynoq District",
    district_muborak: 'Muborak District',
    district_muzrabot: 'Muzrabot District',
    district_namangan: 'Namangan District',
    district_narpay: 'Narpay District',
    district_navbahor: 'Navbahor District',
    district_nishon: 'Nishon District',
    district_norin: 'Norin District',
    district_nukus: 'Nukus District',
    district_nurobod: 'Nurobod District',
    district_nurota: 'Nurota District',
    district_ohangaron: 'Ohangaron District',
    district_olmazor: 'Olmazor District',
    district_olot: 'Olot District',
    district_oltiariq: 'Oltiariq District',
    district_oltinkol: "Oltinko'l District",
    district_oltinsoy: 'Oltinsoy District',
    district_oqdaryo: 'Oqdaryo District',
    district_oqoltin: 'Oqoltin District',
    district_oqqorgon: "Oqqo'rg'on District",
    district_ortachirchiq: "O'rtachirchiq District",
    district_parkent: 'Parkent District',
    district_pastdargom: "Pastdarg'om District",
    district_paxtachi: 'Paxtachi District',
    district_paxtakor: 'Paxtakor District',
    district_paxtaobod: 'Paxtaobod District',
    district_payariq: 'Payariq District',
    district_peshku: 'Peshku District',
    district_piskent: 'Piskent District',
    district_pop: 'Pop District',
    district_qamashi: 'Qamashi District',
    district_qanlikol: "Qanliko'l District",
    district_qarshi: 'Qarshi District',
    district_qibray: 'Qibray District',
    district_qiziltepa: 'Qiziltepa District',
    district_qiziriq: 'Qiziriq District',
    district_qongirot: "Qo'ng'irot District",
    district_qorakol: "Qorako'l District",
    district_qoraozak: "Qorao'zak District",
    district_qorgontepa: "Qo'rg'ontepa District",
    district_qorovulbozor: 'Qorovulbozor District',
    district_qoshkopir: "Qo'shko'pir District",
    district_qoshrabot: "Qo'shrabot District",
    district_qoshtepa: "Qo'shtepa District",
    district_qumqorgon: "Qumqo'rg'on District",
    district_quva: 'Quva District',
    district_quyichirchiq: 'Quyichirchiq District',
    district_rishton: 'Rishton District',
    district_romitan: 'Romitan District',
    district_samarqand: 'Samarkand District',
    district_sardoba: 'Sardoba District',
    district_sariosiyo: 'Sariosiyo District',
    district_sayxunobod: 'Sayxunobod District',
    district_sergeli: 'Sergeli District',
    district_shahrisabz: 'Shahrisabz District',
    district_shahrixon: 'Shahrixon District',
    district_sharof_rashidov: 'Sharof Rashidov District',
    district_shayxontoxur: 'Shayxontohur District',
    district_sherobod: 'Sherobod District',
    district_shofirkon: 'Shofirkon District',
    district_shorchi: "Sho'rchi District",
    district_shovot: 'Shovot District',
    district_shumanay: 'Shumanay District',
    district_sirdaryo: 'Sirdaryo District',
    district_sox: "So'x District",
    district_taxiatosh: 'Taxiatosh District',
    district_taxtakopir: "Taxtako'pir District",
    district_termiz: 'Termez District',
    district_tomdi: 'Tomdi District',
    district_toraqorgon: "To'raqo'rg'on District",
    district_tortkol: "To'rtko'l District",
    district_toshkent: 'Tashkent District',
    district_toshloq: 'Toshloq District',
    district_toyloq: 'Toyloq District',
    district_tuproqqala: "Tuproqqal'a District",
    district_uchkoprik: "Uchko'prik District",
    district_uchqorgon: "Uchqo'rg'on District",
    district_uchquduq: 'Uchquduq District',
    district_uchtepa: 'Uchtepa District',
    district_ulugnor: "Ulug'nor District",
    district_urganch: 'Urgench District',
    district_urgut: 'Urgut District',
    district_uychi: 'Uychi District',
    district_uzbekiston: 'Uzbekistan District',
    district_uzun: 'Uzun District',
    district_vobkent: 'Vobkent District',
    district_xatirchi: 'Xatirchi District',
    district_xiva: 'Khiva District',
    district_xojaobod: "Xo'jaobod District",
    district_xojayli: "Xo'jayli District",
    district_xonqa: 'Xonqa District',
    district_xovos: 'Xovos District',
    district_yakkabog: "Yakkabog' District",
    district_yakkasaray: 'Yakkasaray District',
    district_yangiariq: 'Yangiariq District',
    district_yangibozor: 'Yangibozor District',
    district_yangihayot: 'Yangihayot District',
    district_yangiobod: 'Yangiobod District',
    district_yangiqorgon: "Yangiqo'rg'on District",
    district_yangiyol: "Yangiyo'l District",
    district_yashnobod: 'Yashnobod District',
    district_yozyovon: 'Yozyovon District',
    district_yunusobod: 'Yunusobod District',
    district_yuqorichirchiq: 'Yuqorichirchiq District',
    district_zafarobod: 'Zafarobod District',
    district_zangiota: 'Zangiota District',
    district_zarbdor: 'Zarbdor District',
    district_zomin: 'Zomin District',
  },
};
